import "./NotFound.css";
import { Link } from "react-router-dom";
import StarryBackground from "./starrybackground";

const NotFound = () => {
  return (
    <div>
      <StarryBackground />
      <div className="not-found-container full-width">
        <div className="not-found-content">
          <div className="error-code">
            <img
              src="assets/img/pagenotfound/404text.png"
              alt="page-not-found"
            />
          </div>
          <div className="error-message">Page Not Found</div>
          <div className="error-description">
            The page you are looking for does not exist.
          </div>
          <Link to="/" className="home-button">
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
